import md5 from "md5";

export class Md5Utils {
  public static calcMd5(payload) {
    return md5(payload);
  }
}
